export default "__VITE_ASSET__009be1b0__"